import _ from 'lodash';
import React from 'react';
import Rx from 'rx';
import VisibilitySensor from 'react-visibility-sensor';
import classNames from 'classnames';

import ubBanzai from 'ub/control/banzai-features';
import FontListItem from './font-list-item';
import styles from './font-list.scss';
import FontNotFound from './font-not-found';

const timeBuffer = ubBanzai.getFeatureValue('fontTimeBuffer');
const countBuffer = ubBanzai.getFeatureValue('fontCountBuffer');

const EMPTY_LENGTH = 0;

class FontList extends React.Component {
  constructor() {
    super();

    this.getGridItems = this.getGridItems.bind(this);
    this.lazyLoadDomNodes = this.lazyLoadDomNodes.bind(this);

    this.visibilityChangedSubject = new Rx.Subject();

    this.requestFontLoadSubscription = this.visibilityChangedSubject
      .filter((ev) => ev.visible)
      .map((ev) => ev.fontFamily)
      .bufferWithTimeOrCount(timeBuffer, countBuffer)
      .filter((ev) => ev.length > EMPTY_LENGTH) // Prevents emitting empty buffer
      .subscribe((fontsArray) => {
        this.props.modalActionsSubject.onNext({
          type: 'loadPreviewGoogleFonts',
          data: fontsArray
        });
      });
  }

  componentDidMount() {
    this.scrollWrapper.addEventListener('scroll', this.lazyLoadDomNodes);

    if (_.isEmpty(this.props.fontList)) {
      this.fetchFontList();
    }
  }

  componentWillUnmount() {
    this.scrollWrapper.removeEventListener('scroll', this.lazyLoadDomNodes);

    this.requestFontLoadSubscription.dispose();
  }

  lazyLoadDomNodes() {
    const bottmScrollPosition = this.scrollWrapper.scrollTop + this.scrollWrapper.clientHeight;
    const scrollDistanceFromBottom = this.scrollWrapper.scrollHeight - bottmScrollPosition;
    const triggerValue = 1500;

    if (scrollDistanceFromBottom < triggerValue) {
      this.fetchFontList();
    }
  }

  fetchFontList() {
    if (!this.props.isLazyLoading) {
      this.props.modalActionsSubject.onNext({type: 'fetchFonts'});
    }
  }

  getGridItems() {
    return _.map(this.props.fontList, (fontData, key) => {
      const onChange = (isVisible) => {
        this.visibilityChangedSubject.onNext({
          fontFamily: fontData.family,
          visible: isVisible
        });
      };

      return (
        <VisibilitySensor
          key={key}
          onChange={onChange}
          partialVisibility
          // Prevents further onChange calls if font has already loaded
          active={!fontData.loaded}
        >
          <FontListItem
            family={fontData.family}
            variants={fontData.variants}
            loaded={fontData.loaded}
            fontAdded={fontData.isAdded}
            modalActionsSubject={this.props.modalActionsSubject}
          />
        </VisibilitySensor>
      );
    });
  }

  render() {
    const noFontFound = _.isEmpty(this.props.fontList);

    const _ref = (scrollWrapper) => {
      this.scrollWrapper = scrollWrapper;
    };

    const scrollerClassName = classNames(
      styles.scroller,
      styles[noFontFound ? 'hide' : 'show']
    );

    const fontNotFoundError = noFontFound ? <FontNotFound /> : null;

    return (
      <div className={styles.wrapper}>
        {fontNotFoundError}
        <div ref={_ref} className={scrollerClassName}>
          <div className={styles.grid}>
            {this.getGridItems()}
          </div>
        </div>
      </div>
    );
  }
}

FontList.propTypes = {
  fontList: React.PropTypes.object,
  isLazyLoading: React.PropTypes.bool,
  modalActionsSubject: React.PropTypes.object
};

export default FontList;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-list/font-list.jsx